import { effects } from 'redux-saga'
import moment from 'moment'

import { RECEIVE_CREDENTIALS, refreshCredentials } from '../../modules/authentication'
import getHmac from './hmac'

export default function* wait() {
  const hmac = yield effects.call(getHmac)

  if (hmac === null) {
    // We've never authenticated and do not have a HMAC.
    return null
  }

  const expires = hmac.get('expires') ? moment(hmac.get('expires')) : null

  if (!expires || expires.isBefore()) {
    yield effects.put.resolve(refreshCredentials())
    yield effects.take(RECEIVE_CREDENTIALS)

    return effects.call(wait)
  }

  return hmac
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/authentication/wait.js